import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { map } from 'rxjs/operators';
import { toArray } from 'lodash';
import { HistoryData } from "./history";
import { TrackingProvider, _TRACKING_ENTITIES } from "./tracking";
import { Utilities } from "./utilities";
import { IStand } from "shared/models/commercial-sample.model";

@Injectable()
export class CommercialSampleData {
  constructor(
    private historyData: HistoryData,
    private tracking: TrackingProvider,
    private afDb: AngularFireDatabase,
    private utilities: Utilities
  ) { }

  // public getEventCommercialSampleList(clientId: string, id: string): Observable<any[]> {
  //   return this.afDb
  //     .list(`Clients/${clientId}/Events/${id}/CommercialSamples`)
  //     .valueChanges()
  //     .pipe(
  //       map((data: any) => {
  //         data.map((item) => {
  //           item.categories = toArray(item.categories);
  //         });
  //         return data;
  //       })
  //     );
  // }

  // public saveClientCommercialSample(clientId: string, sample: any) {
  //   if (sample.id === "") {
  //     sample.id = this.afDb.createPushId();
  //   }
  //   return this.afDb.object(`Clients/${clientId}/CommercialSamples/${sample.id}`)
  //     .update(sample)
  //     .then((() =>
  //       this.historyData.set(
  //         `Module client commercial sample content`,
  //         "commercial_sample",
  //         "update",
  //         sample
  //       )
  //     ))
  //     .then(() => {
  //       this.tracking.trackEntity(_TRACKING_ENTITIES.commercialSamples, sample.id, clientId, null, sample, "Creacion/Actualizacion comercial sample general")
  //     })
  // }

  // public getClientCommercialSampleList(clientId: string) {
  //   return this.afDb.list(`Clients/${clientId}/CommercialSamples`).valueChanges();
  // }

  public getStandList(clientId: string, eventId: string) {
    let reference = `Clients/${clientId}/Interactivity/Stand`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Stand`;
    }
    return this.afDb.list<IStand>(reference).valueChanges();
  }

  public getStandById(clientId: string, standId: string, eventId: string): any {
    let reference = `Clients/${clientId}/Interactivity/Stand/${standId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Stand/${standId}`;
    }
    return this.afDb.object<IStand>(reference).valueChanges();
  }

  public createOrUpdateStand(clientId: string, eventId: string, payload: IStand): Promise<any> {
    if (payload.id === "") {
      payload.id = this.afDb.createPushId();
    }
    let reference = `Clients/${clientId}/Interactivity/Stand/${payload.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Stand/${payload.id}`;
    }
    return this.afDb.object<IStand>(reference).update(payload)
      .then(() => {
        this.tracking.trackEntityPromise(_TRACKING_ENTITIES.stand, payload.id, clientId, eventId, payload, "Tracking en la creacion/actualizacion de stand");
      })
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/commercial-sample.ts